import { makeStyles } from '@material-ui/core';

// Here z-index fixes position, when page has another bottom-sheet, component,
// so login bottom-sheet must be overhead
const useStyles = makeStyles(() => ({
  root: {
    '&:after': {
      zIndex: 13,
    },
    '& [data-rsbs-overlay="true"]': {
      zIndex: 13,
    },
  },
  logo: {
    display: 'block',
    margin: '0 auto',
    width: 160,
  },
}));

export default useStyles;
